import { Box } from '@mui/material';

import {
  feedbackComponentContainerStyle,
} from './feedbackComponentContainerStyle';

interface FeedbackComponentContainerProps {
  children: JSX.Element | JSX.Element[];
  matchesMD: boolean
}

export const FeedbackComponentContainer = (
  {
    children,
    matchesMD,
  }: FeedbackComponentContainerProps,
) => (
  <Box
    sx={
      matchesMD
        ? feedbackComponentContainerStyle.desktop
        : feedbackComponentContainerStyle.mobile
    }
  >
    {children}
  </Box>
);
